// Generated by purs version 0.15.16
import * as API_Pagination from "../API.Pagination/index.js";
import * as Data_Argonaut_Core from "../Data.Argonaut.Core/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as GraphQL_Query from "../GraphQL.Query/index.js";
import * as GraphQL_Shape from "../GraphQL.Shape/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_Util from "../Internal.Util/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Widgets_BetterSelect from "../Widgets.BetterSelect/index.js";
var length = /* #__PURE__ */ Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var rltvCons = /* #__PURE__ */ GraphQL_Query.rltvCons(GraphQL_Query.rltvNil);
var position_idIsSymbol = {
    reflectSymbol: function () {
        return "position_id";
    }
};
var hqtArray = /* #__PURE__ */ GraphQL_Type.hqtArray(GraphQL_Type.hqtID);
var encodeJsonArray = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(GraphQL_Type.encQID);
var rltvfConsOther = /* #__PURE__ */ GraphQL_Query.rltvfConsOther(GraphQL_Query.rltvfNil);
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonString));
var gDecodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString));
var gDecodeJsonCons2 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ GraphQL_Type.decRNTY(Data_Argonaut_Decode_Class.decodeJsonString)));
var sub_categoryIsSymbol = {
    reflectSymbol: function () {
        return "sub_category";
    }
};
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var descriptionIsSymbol = {
    reflectSymbol: function () {
        return "description";
    }
};
var categoryIsSymbol = {
    reflectSymbol: function () {
        return "category";
    }
};
var rlhsCons = /* #__PURE__ */ GraphQL_Shape.rlhsCons(GraphQL_Shape.rlhsNil);
var maybeShape = /* #__PURE__ */ GraphQL_Shape.maybeShape(GraphQL_Shape.scalarShape);
var recShape = /* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(sub_categoryIsSymbol)(maybeShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())(descriptionIsSymbol)(GraphQL_Shape.scalarShape)()())(categoryIsSymbol)(maybeShape)()())();
var pageQR = /* #__PURE__ */ API_Pagination.pageQR(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonNil)(sub_categoryIsSymbol)()())(idIsSymbol)()())(descriptionIsSymbol)()())(categoryIsSymbol)()())())(recShape);
var buildQuery = /* #__PURE__ */ GraphQL_Query.buildQuery(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ rltvCons(position_idIsSymbol)(hqtArray)(encodeJsonArray)()())(/* #__PURE__ */ rltvfConsOther(position_idIsSymbol)())())(pageQR);
var typeIsSymbol = {
    reflectSymbol: function () {
        return "type";
    }
};
var rltvCons1 = /* #__PURE__ */ rltvCons(typeIsSymbol);
var encRNTY = /* #__PURE__ */ GraphQL_Type.encRNTY(Data_Argonaut_Encode_Class.encodeJsonJString);
var encodeJsonArray1 = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(encRNTY);
var firstIsSymbol = {
    reflectSymbol: function () {
        return "first";
    }
};
var rltvfConsOther1 = /* #__PURE__ */ GraphQL_Query.rltvfConsOther(/* #__PURE__ */ rltvfConsOther(typeIsSymbol)());
var gDecodeJsonCons3 = /* #__PURE__ */ gDecodeJsonCons1(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var labelIsSymbol = {
    reflectSymbol: function () {
        return "label";
    }
};
var buildQuery1 = /* #__PURE__ */ GraphQL_Query.buildQuery(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ rltvCons1(/* #__PURE__ */ GraphQL_Type.hqtArray(/* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "OccupationType";
    }
})))(encodeJsonArray1)()())(firstIsSymbol)(GraphQL_Type.hqtInt)(Data_Argonaut_Encode_Class.encodeJsonInt)()())(/* #__PURE__ */ rltvfConsOther1(firstIsSymbol)())())(/* #__PURE__ */ API_Pagination.unpagedQR(/* #__PURE__ */ GraphQL_Query.arrayQR(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons3(labelIsSymbol)()())(idIsSymbol)()())()))(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(labelIsSymbol)(GraphQL_Shape.scalarShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())()))));
var occupation_idIsSymbol = {
    reflectSymbol: function () {
        return "occupation_id";
    }
};
var buildQuery2 = /* #__PURE__ */ GraphQL_Query.buildQuery(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ rltvCons(occupation_idIsSymbol)(hqtArray)(encodeJsonArray)()())(/* #__PURE__ */ rltvfConsOther(occupation_idIsSymbol)())())(pageQR);
var map1 = /* #__PURE__ */ Data_Functor.map(GraphQL_Query.queryFunctor);
var whereIsSymbol = {
    reflectSymbol: function () {
        return "where";
    }
};
var relationIsSymbol = {
    reflectSymbol: function () {
        return "relation";
    }
};
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(relationIsSymbol)();
var HASIsSymbol = {
    reflectSymbol: function () {
        return "HAS";
    }
};
var conditionIsSymbol = {
    reflectSymbol: function () {
        return "condition";
    }
};
var searchIsSymbol = {
    reflectSymbol: function () {
        return "search";
    }
};
var rltvCons2 = /* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ rltvCons(whereIsSymbol)(/* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "QueryEmployersWhereWhereConditions";
    }
}))(/* #__PURE__ */ GraphQL_Type.encRNTY(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(gEncodeJsonCons)())(Data_Argonaut_Encode_Class.gEncodeJsonNil)(HASIsSymbol)())())(gEncodeJsonCons)(conditionIsSymbol)())())(Data_Argonaut_Encode_Class.gEncodeJsonNil)(HASIsSymbol)())()))()())(searchIsSymbol)(GraphQL_Type.hqtStr)(Data_Argonaut_Encode_Class.encodeJsonJString)()();
var rltvfConsRec = /* #__PURE__ */ GraphQL_Query.rltvfConsRec(GraphQL_Query.rltvfNil)(HASIsSymbol)()();
var rltvfConsOther2 = /* #__PURE__ */ rltvfConsOther(relationIsSymbol)();
var rltvfConsOther3 = /* #__PURE__ */ GraphQL_Query.rltvfConsOther(/* #__PURE__ */ GraphQL_Query.rltvfNamedTypeRec(GraphQL_Query.rltvfNil)(whereIsSymbol)()()(/* #__PURE__ */ rltvfConsRec(/* #__PURE__ */ GraphQL_Query.rltvfConsRec(rltvfConsOther2)(conditionIsSymbol)()()(/* #__PURE__ */ rltvfConsRec(rltvfConsOther2)))))(searchIsSymbol)();
var dataIsSymbol = {
    reflectSymbol: function () {
        return "data";
    }
};
var nameIsSymbol = {
    reflectSymbol: function () {
        return "name";
    }
};
var gDecodeJsonCons4 = /* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons3(nameIsSymbol)()());
var expectationsIsSymbol = {
    reflectSymbol: function () {
        return "expectations";
    }
};
var positionsIsSymbol = {
    reflectSymbol: function () {
        return "positions";
    }
};
var companyIsSymbol = {
    reflectSymbol: function () {
        return "company";
    }
};
var rlhsCons1 = /* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(nameIsSymbol)(GraphQL_Shape.scalarShape)()());
var unpagedQR = /* #__PURE__ */ API_Pagination.unpagedQR(/* #__PURE__ */ GraphQL_Query.arrayQR(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons2(Data_Argonaut_Decode_Class.gDecodeJsonNil)(idIsSymbol)()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(dataIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons4(idIsSymbol)()())(expectationsIsSymbol)()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(positionsIsSymbol)()())(idIsSymbol)()())(companyIsSymbol)()())()))(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(positionsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons1(idIsSymbol)(GraphQL_Shape.scalarShape)()())(expectationsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons(dataIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons(idIsSymbol)(GraphQL_Shape.scalarShape)()())()))()())())()())()))()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())(companyIsSymbol)(GraphQL_Shape.scalarShape)()())())));
var buildQuery3 = /* #__PURE__ */ GraphQL_Query.buildQuery(/* #__PURE__ */ GraphQL_Query.rlTVars(rltvCons2)(rltvfConsOther3)())(unpagedQR);
var form_idIsSymbol = {
    reflectSymbol: function () {
        return "form_id";
    }
};
var rntyType = /* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "ID";
    }
});
var buildQuery4 = /* #__PURE__ */ GraphQL_Query.buildQuery(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ GraphQL_Query.rltvCons(rltvCons2)(form_idIsSymbol)(rntyType)(encRNTY)()())(/* #__PURE__ */ GraphQL_Query.rltvfConsOther(rltvfConsOther3)(form_idIsSymbol)())())(unpagedQR);
var student_idIsSymbol = {
    reflectSymbol: function () {
        return "student_id";
    }
};
var group_labelIsSymbol = {
    reflectSymbol: function () {
        return "group_label";
    }
};
var rlhsCons2 = /* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons1(labelIsSymbol)(GraphQL_Shape.scalarShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()();
var buildQuery5 = /* #__PURE__ */ GraphQL_Query.buildQuery(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ rltvCons(student_idIsSymbol)(rntyType)(encRNTY)()())(/* #__PURE__ */ rltvfConsOther(student_idIsSymbol)())())(/* #__PURE__ */ GraphQL_Query.arrayQR(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons4(labelIsSymbol)()())(idIsSymbol)()())(group_labelIsSymbol)()())()))(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(rlhsCons2)(group_labelIsSymbol)(GraphQL_Shape.scalarShape)()())())));
var course_idIsSymbol = {
    reflectSymbol: function () {
        return "course_id";
    }
};
var Overall = /* #__PURE__ */ (function () {
    function Overall() {

    };
    Overall.value = new Overall();
    return Overall;
})();
var Specific = /* #__PURE__ */ (function () {
    function Specific() {

    };
    Specific.value = new Specific();
    return Specific;
})();
var decodeJsonExpectationType = {
    decodeJson: function (json) {
        var v = Data_Argonaut_Core.toString(json);
        if (v instanceof Data_Maybe.Just && v.value0 === "OVERALL") {
            return new Data_Either.Right(Overall.value);
        };
        if (v instanceof Data_Maybe.Just && v.value0 === "SPECIFIC") {
            return new Data_Either.Right(Specific.value);
        };
        return new Data_Either.Left(new Data_Argonaut_Decode_Error.UnexpectedValue(json));
    }
};
var processEmployerPos = /* #__PURE__ */ (function () {
    var filteredPositions = function (emp) {
        return Data_Array.filter(function (pos) {
            return length(pos.expectations.data) > 0;
        })(emp.positions);
    };
    var processEmployer = function (emp) {
        return map(function (pos) {
            return {
                label: emp.company + (" - " + pos.name),
                value: {
                    id: pos.id
                }
            };
        })(filteredPositions(emp));
    };
    return Data_Array.concatMap(processEmployer);
})();
var positionExpectationsQuery = function (id) {
    return buildQuery("expectations")({
        position_id: [ new GraphQL_Type.QID(id) ]
    });
};
var occupationListQuery = function (otype$prime) {
    var otype = GraphQL_Type.namedType(otype$prime);
    return API_Pagination.unpaged(buildQuery1("occupations")({
        type: [ otype ],
        first: 2147483647
    }));
};
var occupationListSelAff = function (otype) {
    return Widgets_BetterSelect.simpleFrontendSearch(function (v) {
        return v.label;
    })(Widgets_BetterSelect.wrapSelectOption(function (v) {
        return v.label;
    })(occupationListQuery(otype)));
};
var nocExpectationsQuery = function (id) {
    return buildQuery2("expectations")({
        occupation_id: [ new GraphQL_Type.QID(id) ]
    });
};
var tradeExpectationsQuery = nocExpectationsQuery;
var groupCourseToExp = function (v) {
    return {
        id: v.id,
        name: v.name,
        label: v.label
    };
};
var expectationFields = /* #__PURE__ */ (function () {
    return GraphQL_Shape.shapeToStringInner(GraphQL_Shape.shapeOf(recShape)(Type_Proxy["Proxy"].value));
})();
var expCourseToGroup = function (v) {
    return {
        id: v.id,
        name: v.name,
        label: v.label,
        group_label: ""
    };
};
var exTyQT = {
    gqlType: function (v) {
        return new GraphQL_Type.QType("ExpectationType");
    }
};
var encExType = {
    encodeJson: function (v) {
        if (v instanceof Overall) {
            return Data_Argonaut_Core.fromString("OVERALL");
        };
        if (v instanceof Specific) {
            return Data_Argonaut_Core.fromString("SPECIFIC");
        };
        throw new Error("Failed pattern match at API.Expectations (line 147, column 1 - line 149, column 50): " + [ v.constructor.name ]);
    }
};
var buildQuery6 = /* #__PURE__ */ GraphQL_Query.buildQuery(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ GraphQL_Query.rltvCons(/* #__PURE__ */ rltvCons1(/* #__PURE__ */ GraphQL_Type.hqtMaybe(/* #__PURE__ */ GraphQL_Type.hqtArray(exTyQT)))(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(encExType)))()())(course_idIsSymbol)(/* #__PURE__ */ GraphQL_Type.hqtArray(rntyType))(encodeJsonArray1)()())(/* #__PURE__ */ rltvfConsOther1(course_idIsSymbol)())())(pageQR);
var employerWhere = /* #__PURE__ */ GraphQL_Type.namedType({
    HAS: {
        relation: "positions",
        condition: {
            HAS: {
                relation: "expectations"
            }
        }
    }
});
var employerPosListQuery_ = function (search) {
    return map1(processEmployerPos)(API_Pagination.unpaged(buildQuery3("employers")({
        search: search,
        where: employerWhere
    })));
};
var employerPosSearchSelAff_ = /* #__PURE__ */ (function () {
    return new Widgets_BetterSelect.BackendSearch(function (search) {
        return employerPosListQuery_(search);
    });
})();
var employerPosListQuery = function (form_id) {
    return function (search) {
        return map1(processEmployerPos)(API_Pagination.unpaged(buildQuery4("employers")({
            form_id: form_id,
            search: search,
            where: employerWhere
        })));
    };
};
var employerPosSearchSelAff = function (docId) {
    return new Widgets_BetterSelect.BackendSearch(function (search) {
        return employerPosListQuery(docId)(search);
    });
};
var courseListQuery = function (student_id) {
    return buildQuery5("courses")({
        student_id: student_id
    });
};
var courseListSelAff = function (student) {
    return Widgets_BetterSelect.simpleFrontendSearch(function (v) {
        return v.label;
    })(Widgets_BetterSelect.wrapSelectOption(function (v) {
        return v.label;
    })(courseListQuery(student)));
};
var courseFields = /* #__PURE__ */ (function () {
    return GraphQL_Shape.shapeToStringInner(GraphQL_Shape.shapeOf(GraphQL_Shape.recShape(rlhsCons2)())(Type_Proxy["Proxy"].value));
})();
var courseExpectationsQuery = function (types) {
    return function (id) {
        return buildQuery6("expectations")({
            course_id: [ id ],
            type: Internal_Util.justIf(length(types) > 0)(types)
        });
    };
};
export {
    courseFields,
    groupCourseToExp,
    expCourseToGroup,
    courseListQuery,
    courseListSelAff,
    occupationListQuery,
    occupationListSelAff,
    employerPosSearchSelAff,
    employerWhere,
    employerPosListQuery,
    employerPosSearchSelAff_,
    employerPosListQuery_,
    processEmployerPos,
    Overall,
    Specific,
    expectationFields,
    courseExpectationsQuery,
    nocExpectationsQuery,
    tradeExpectationsQuery,
    positionExpectationsQuery,
    encExType,
    exTyQT,
    decodeJsonExpectationType
};
//# sourceMappingURL=index.js.map
